import React, { useCallback, useContext, useEffect, useState } from 'react';

import {
  Button,
  Table,
  Row,
} from '@digital/ui';
import { Tooltip } from 'antd';

import ModalFinalizarEtapaFaturamentoDireto from '../ModalFinalizarEtapaFaturamentoDireto';
import { downloadAnexoDemanda, excluiAnexo } from '../../../../../api/demanda';
import QuestionarioContextProvider from '../../../../../hooks/useQuestionario';
import ModalCreateDocumento from '../ModalCreateDocumento';
import ModalFinalizarEtapaDados from '../ModalFinalizarEtapaDados';
import ModalComentariosAnexoDemanda from '../ModalComentariosAnexoDemanda';
import { baixarTemplatesDemanda, baixarTemplateTakeOffAditivoPCS } from '@app/api/template';
import './custom.css';
import { getExportarTaKeOf } from '@app/api/contrato/planilhaQuantidadeContrato';
import { UploadComponent } from '@app/components';
import IncluirAnexoFaturamentoDireto from '../../dadosGerais/IncluirAnexoFaturamentoDireto';

const UploadArquivosFaturamentoDiretoFields = () => {
  const { templateContext, getTemplates, setTemplateContext, demandaData, update, setUpdate, capex, opex } = useContext(
    QuestionarioContextProvider,
  );
  const [statusCode, setStatusCode] = useState<number>();

  useEffect(() => {
    async function fetchData() {
      await getTemplates(demandaData && demandaData.id);
    }
    if (demandaData) {
      setStatusCode(demandaData.statusCodigo);
    }

    fetchData();
  }, [demandaData, demandaData]);

  useEffect(() => {
    if (!templateContext || !setTemplateContext) return;

    const formularioExiste = templateContext.some(c =>
      c.descricaoDocumento && c.descricaoDocumento.includes('Autorização de Faturamento Direto'),
    );

    if (!formularioExiste) {
      const novoItem = {
        id: 'formulario-autorizacao-faturamento-direto',
        descricaoDocumento: 'Autorização de Faturamento Direto',
        obrigatorio: true,
        automatico: false,
        demandaId: (demandaData && demandaData.id) || '',
        //arquivoAtual: undefined,
        //exibir: false,
        //historicoComentariosAnexoDemanda: [],
        //contemComentarios: false,
        //aprovado: false,
      };

      setTemplateContext([...templateContext, novoItem]);
    }
  }, [templateContext, demandaData]);

  const handleExcluir = useCallback(
    async (id: string, obrigatorio: boolean) => {
      await excluiAnexo({ id, obrigatorio });
      setUpdate(!update);
      await getTemplates(demandaData && demandaData.id);
    },
    [getTemplates, demandaData],
  );

  const handleBaixarTemplates = () => {
    if (demandaData) {
      baixarTemplatesDemanda(demandaData.id);
    }
  };



  const [arquivo, setArquivo] = useState<boolean>(true);

  const columns = [
    {
      title: 'Anexos',
      dataIndex: 'descricaoDocumento',
    },
    {
      title: 'Ações',
      width: '25%',
      className: 'td-centralizado',
      render: (index: any, record: any) => (
        <>
          {record && (
            <>
              {record.arquivoAtual === undefined && (
                <IncluirAnexoFaturamentoDireto DescricaoDocumento={record.descricaoDocumento}
                onUpdate={()=>{ getTemplates(demandaData && demandaData.id);}}
                />
              )}
              {record.arquivoAtual && (
                <>
                  {!record.aprovado ? (
                    <UploadComponent
                      id={record.arquivos[0].id}
                      nomeIdFormulario={'Id'}
                      enderecoApi={'anexoDemanda/Upload'}
                      idDoComponente={record.id}
                      iconName="messaging-attach"
                      retorno={async data => {
                        if (data.valid) {
                          await getTemplates(demandaData && demandaData.id);
                        }
                      }}
                      hasFile={record.arquivoAtual && record.arquivoAtual.local}
                      label="Anexar"
                      buttonClass="labeled"
                    />
                  ) : (
                    <></>
                  )}
                </>
              )}
            </>
          )}
          {record.arquivoAtual && record.arquivoAtual.local && (
            <>
              <Tooltip title="Baixar Arquivo">
                <Button
                  id={`mrn-button-download-${record.id}`}
                  style={{ marginLeft: '10px' }}
                  icon="ui-download"
                  type="link"
                  onClick={() => {
                    downloadAnexoDemanda(record.arquivoAtual.id, record.arquivoAtual.nome);
                  }}
                  title="Baixar"
                  className="labeled"
                />
              </Tooltip>
            </>
          )}
          {record && record.arquivoAtual && !record.aprovado && (
            <Tooltip title="Excluir Anexo">
              <Button
                id={`mrn-button-delete-${record.id}`}
                style={{ marginLeft: '10px' }}
                type="link"
                icon="science-minus"
                onClick={() => {
                  handleExcluir(record.id, record.obrigatorio);
                }}
                disabled={statusCode === 7 || statusCode === 9 || statusCode === 2}
                title="Excluir"
                className="labeled"
              />
            </Tooltip>
          )}
        </>
      ),
    },
    {
      title: 'Comentários',
      dataIndex: 'historicoComentariosAnexoDemanda',
      width: '5%',
      className: 'td-centralizado',
      render: (index: any, record: any) => {
        return (
          <Tooltip title="Comentários">
            <ModalComentariosAnexoDemanda
              preSuprimentos={false}
              anexoId={record.id}
              contemComentario={record && record.historicoComentariosAnexoDemanda && record.historicoComentariosAnexoDemanda.length > 0}
            />
          </Tooltip>
        );
      },
    },
    {
      title: 'Obrigatório',
      width: '5%',
      render: (text: any, record: any) =>
        record.obrigatorio !== undefined ? (record.obrigatorio ? 'Sim' : 'Não') : 'Não',
    },
  ];


  return (
    <>
      {statusCode !== 7 && statusCode !== 2 && statusCode !== 9 && statusCode !== 6 && (
        <Row style={{ paddingLeft: '10px' }}>
          <ModalCreateDocumento getTemplates={getTemplates} />
        </Row>
      )}
      <Row style={{ paddingLeft: '10px', paddingRight: '5px' }}>
        <Table
          rowKey="id"
          columns={columns}
          dataSource={templateContext || []}
          pagination={false}
        />
      </Row>
    </>
  );
};

export default UploadArquivosFaturamentoDiretoFields;
